import { service } from './index';
import Datepicker from 'vuejs-datepicker';
import dayjs from 'dayjs';
import _ from 'lodash';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
export const name = 'DATE.render';
const datePickerLanguage = {
    rtl: false,
    yearSuffix: '',
    ymd: true,
    days: ['7', '1', '2', '3', '4', '5', '6'],
    language: 'Custom',
    months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
    monthsAbbr: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
};
function dateToText(value) {
    if (!value)
        return value;
    const i18n = injectService(i18nSymbol);
    const dateFormat = i18n.t('global.format.date');
    if (typeof value === 'string') {
        value = value.replace(/\./g, '-');
    }
    return dayjs(value).format(`${dateFormat}`);
}
function formatInputDate(date = '') {
    if (!date)
        return '';
    return dateToText(dayjs(date).format('YYYY-MM-DD'));
}
function formatOutputDate(date = '') {
    return dayjs(date).format('YYYYMMDD');
}
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    return [
        // @ts-ignore
        <div class="xtable-cell-render" attrs={attrs}>
            {formatInputDate(row[column.property])}
        </div>,
    ];
}
// 可编辑显示模板
const renderCell = renderDefault;
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return formatInputDate(row[column.property]);
}
// 校验
function validator(date) {
    return _.isEmpty(date) || dayjs(date).isValid();
}
// 格式化
function formatter(date) {
    if (!validator(date))
        return '';
    return !date ? '' : formatOutputDate(date);
}
// 可编辑激活模板
function renderEdit(h, renderOpts, params) {
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    const value = formatInputDate(row[column.property]);
    const editor = (
    // @ts-ignore
    <div class="xtable-cell-editor" attrs={attrs}>
            <input class="vdp-input" value={value} 
    // @ts-ignore
    onchange={e => {
            const _value = e.target.value;
            validator(_value) && service.updateCellValue(row, column, _value ? formatter(_value) : '');
        }}/>
            <Datepicker value={value} inline language={datePickerLanguage} onSelected={date => service.updateCellValue(row, column, formatter(date))}/>
        </div>);
    this.$nextTick(() => {
        service.updateEditorRect(editor, row, column);
    });
    return [editor];
}
export default {
    renderDefault,
    renderEdit,
    renderCell,
    exportMethod,
    validator,
    formatter,
};
